export { innerSVG, reduceSVGToGroup, wrapGroupsInSVG, removeConnectionPoints };

// return all the elements inside SVG element.
function innerSVG(circuit) {
  var svgContent = circuit.substr(circuit.indexOf('<svg'));
  var svgTagEndIndex = svgContent.indexOf('>');
  return svgContent.substr(svgTagEndIndex + 1).replace('</svg>', '');
}

function reduceSVGToGroup(circuit, xOffset, yOffset, id, matrix) {
  var endSvgOffset = circuit.indexOf('>', circuit.indexOf('<svg')) + 1;
  var closeSvgOffset = circuit.indexOf('</svg>', endSvgOffset);
  var innerSvg = circuit.substring(endSvgOffset, closeSvgOffset);
  var matrixClause = matrix
    ? ` matrix(${matrix[0]},${matrix[3]},${matrix[1]},${matrix[4]},${matrix[2]},${matrix[5]})`
    : '';
  return `<g id="${id}" transform="translate(${xOffset},${yOffset})${matrixClause}">` + innerSvg + '</g>';
}

// group all circuits inside an SVG element.
function wrapGroupsInSVG(groups, width, height) {
  let svgWidth = width ? width : 640;
  let svgHeight = height ? height : 480;
  var result = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${svgWidth.toString()}" height="${svgHeight.toString()}">`;
  for (var i = 0; i <= groups.length - 1; i++) {
    result += groups[i];
  }
  return (result += '</svg>');
}

// Return a circuit with all the relevant connection points removed
function removeConnectionPoints(circuit, connections, index) {
  // Find the names of all the connection points we need to cull from this circuit
  let names = [];
  for (let connection of connections) {
    if (connection.fromCircuit === index) {
      if (!names.includes[connection.fromOutput]) {
        names.push(connection.fromOutput);
      }
    }
    if (connection.toCircuit === index) {
      if (!names.includes[connection.toInput]) {
        names.push(connection.toInput);
      }
    }
  }
  // Find the names and text ranges of the connection points in the circuit
  // Sort so we start culling from the end and don't have to track offsets for what we've already culled.
  let connectionPoints = _findConnectionPoints(circuit);
  connectionPoints.sort((a, b) => b.position - a.position);
  // Remove the desired connection points
  let newCircuit = circuit;
  for (let point of connectionPoints) {
    if (names.includes(point.name)) {
      newCircuit = newCircuit.substr(0, point.position) + newCircuit.substr(point.endPosition);
    }
  }
  return newCircuit;
}

// Find all the connection points in a circuit with their text ranges and names
function _findConnectionPoints(circuit) {
  let points = [];
  let internalCircuit = circuit.split('\r').join(' ').split('\n').join(' ');
  let groupPattern =
    /<(svg:)?g([^>]+)class\s*=\s*"[^"]*(primary-in|primary-out|secondary-in|secondary-out)[^"]*"([^>]*)>(.*?)<\/(svg:)?g>/g;
  let groupMatch;
  while ((groupMatch = groupPattern.exec(internalCircuit)) != null) {
    let attrPattern = /data-connection-group\s*=\s*"([^"]*)"/g;
    let attrMatch = attrPattern.exec(groupMatch[2]) || attrPattern.exec(groupMatch[4]);
    let attrName = attrMatch ? attrMatch[1] : groupMatch[3].includes('-in') ? 'IN' : 'OUT';
    let point = {
      name: attrName,
      position: groupMatch.index,
      endPosition: groupMatch.index + groupMatch[0].length,
    };
    points.push(point);
  }
  return points;
}
